import styled from 'styled-components';
import StarIcon from '../icons/Star';

const PriorityContainer = styled.div`
  stroke: var(--yellow-500);
  background-color: var(--yellow-100);
  border-radius: 50rem;
  width: 2.5rem;
  height: 2.5rem;
  position: relative;

  svg {
    width: 1.25rem;
    height: 1.25rem;
    position: absolute;
    top: 0.625rem;
    left: 0.625rem;
  }
`;

const Priority = () => {
  return (
    <PriorityContainer>
      <StarIcon />
    </PriorityContainer>
  );
};

export default Priority;
